// @core/api/endpoints/signature/get_signature.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SignatureResponse,
} from '../../../types/signature';

const BASE_PATH = '/signature';

/**
 * Get signature by ID
 * Returns a full signature evidence record including typed evidence payload, certificate reference, TSP token, and request/session metadata captured at signing time.
 */
export async function GetSignature(
  signature_id: string,
  options?: RequestOptions
): Promise<SignatureResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/signatures/:signature_id`;
  requestPath = requestPath.replace(':signature_id', encodeURIComponent(signature_id));
  const requestOptions = options;
  return client.get<SignatureResponse>(requestPath, { ...requestOptions });
}
